<template>
  <div>
    <el-table
      :header-cell-style="tableHeaderColor"
      :data="invoiceList"
      stripe
      style="width: 100%"
    >
      <el-table-column label="請款單標題" width="180">
        <template slot-scope="scope">
          <span class="index-click" @click="directEditInvoice(scope.$index)">
            {{ scope.row.title }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名稱"
        width="180"
      ></el-table-column>
      <el-table-column prop="count" label="幾張"></el-table-column>
      <el-table-column
        prop="totalActualPrice"
        label="原始金額"
      ></el-table-column>
      <el-table-column
        prop="totalServicePrice"
        label="服務金額"
      ></el-table-column>
      <el-table-column prop="requestOrderDate" label="請款日"></el-table-column>
      <el-table-column
        prop="driverReceivePaymentDate"
        label="司機可提款日"
      ></el-table-column>
      <el-table-column prop="invoiceNote" label="請款單備註"></el-table-column>
      <el-table-column label="企業付款">
        <template slot-scope="scope">
          <div v-if="scope.row.actualReceiveDate === null">
            <el-button
              type="primary"
              size="mini"
              @click="enteprprisePayment(scope.$index)"
            >
              付款
            </el-button>
          </div>
          <div v-else>
            {{ scope.row.actualReceiveDate }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="動作">
        <template slot-scope="scope">
          <div v-if="scope.row.actualReceiveDate === null">
            <el-button
              type="primary"
              size="mini"
              @click="addSigning(scope.$index)"
            >
              加入簽單
            </el-button>
          </div>
          <div v-else>
            <el-button
              type="danger"
              size="mini"
              @click="recoverInvoice(scope.$index)"
            >
              恢復未繳費狀態
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下載">
        <template slot-scope="scope">
          <el-button
            circle
            @click="download(scope.row)"
            icon="el-icon-download"
            :loading="isload"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="3" :offset="18">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="clickNewPage"
          :page-size="25"
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>
    <div
      id="updatePaymentDateModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="row">
              <h4>支付時間</h4>
              <input
                type="datetime-local"
                class="inputstyle fontSize16 col-md-9 col-sm-9 col-xs-9"
                v-model="enterprisePaymentDate"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              @click="updatePaymentDate"
            >
              更新
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EnterpriseAPI from '../../assets/js/libs/EnterpriseAPI'
import axios from 'axios'
import { cookies } from '@/utils/cookies'

export default {
  props: ['task', 'invoiceList', 'total'],
  data() {
    return {
      enterprisePaymentDate: '',
      message_list: [
        { item: '不選擇', index: 0 },
        { item: '服務費', index: 1 },
        { item: '提前現領', index: 2 },
      ],
      totalPage: 1,
      page: 1,
      pages_show_list: [],
      npp: 25,
      invoiceIndex: -1,
      isload: false,
    }
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #445465;color: #fff;font-weight: 500;'
      }
    },
    recoverInvoice(index) {
      if (index === -1) return alert('操作錯誤，重新整理')
      let payload = {
        invoiceId: this.invoiceList[index].id,
        enterpriseId: this.invoiceList[index].enterpriseId,
        paymentAt: this.enterprisePaymentDate,
      }
      EnterpriseAPI.put(`enterprise/invoice/pay?task=recover`, payload)
        .then((res) => {
          this.$msg('修改成功')
          this.$emit('updateInvoice', 0)
        })
        .catch((err) => {
          this.$msg('修改失敗，請再試一次')
        })
    },
    download(val) {
      this.isload = true
      axios
        .get(`${EnterpriseAPI.getAPIUrl}enterprise/invoice/excel`, {
          responseType: 'blob',
          params: { invoice_id: val.id },
          headers: {
            'x-access-token': cookies.get('user'),
          },
        })
        .then((res) => {
          console.log(res)
          this.isload = false
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const downloadElement = document.createElement('a')
          const href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          downloadElement.download = `${val.title}_${val.companyName}_請款單.xlsx`
          document.body.appendChild(downloadElement)
          downloadElement.click()
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        })
        .catch(function (error) {
          this.isload = false
          console.log(error)
        })
    },
    addSigning(index) {
      console.log(index)
      this.$router.push({
        name: 'addInvoice',
        query: {
          title: this.invoiceList[index].title,
          companyName: this.invoiceList[index].companyName,
          id: this.invoiceList[index].id,
          enterpriseId: this.invoiceList[index].enterpriseId,
        },
      })
    },
    updatePaymentDate() {
      if (this.invoiceIndex === -1) return alert('操作錯誤，重新整理')
      let payload = {
        invoiceId: this.invoiceList[this.invoiceIndex].id,
        enterpriseId: this.invoiceList[this.invoiceIndex].enterpriseId,
        paymentAt: this.enterprisePaymentDate,
      }
      EnterpriseAPI.put(`enterprise/invoice/pay?task=pay`, payload)
        .then((res) => {
          this.$msg('修改成功')
          this.invoiceIndex = -1
          this.$emit('updateInvoice', 0)
          $('#updatePaymentDateModal').modal('hide')
        })
        .catch((err) => {
          this.$msg('修改失敗，請再試一次')
        })
    },
    enteprprisePayment(index) {
      console.log(index)
      this.invoiceIndex = index
      $('#updatePaymentDateModal').modal('show')
    },
    clickNewPage(page) {
      this.$emit('nextPage', page)
    },
    updateDriverAsk(index) {},
    showNoteModal() {},
    selectAllAskItem() {},
    updateEnterprisePayment(index) {},
    selectAllPaymentItem() {},
    directEditInvoice(index) {
      console.log(this.invoiceList[index])
      this.$router.push({
        name: 'editInvoice',
        query: {
          id: this.invoiceList[index].id,
          enterpriseId: this.invoiceList[index].enterpriseId,
        },
      })
    },
  },
}
</script>
<style scoped>
.index-click {
  text-decoration: underline;
  color: blue;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/company/InvoiceTable.vue